import { SiteFooter } from '@/components/layout/SiteFooter'
import { SiteHeader } from '@/components/layout/SiteHeader'
import { ContactSection } from '@/components/sections/ContactSection'
import { HeroSection } from '@/components/sections/HeroSection'
import { LabSection } from '@/components/sections/LabSection'
import { PhilosophySection } from '@/components/sections/PhilosophySection'

export default function App() {
  return (
    <div className="bg-background text-foreground">
      <SiteHeader />
      <main className="page-snap-container" aria-label="Landing page sections">
        <HeroSection />
        <LabSection />
        <PhilosophySection />
        <ContactSection>
          <SiteFooter className="mt-10 w-full border-t border-border/70 pt-8" />
        </ContactSection>
      </main>
    </div>
  )
}
